/**
 * Login modal component name
 * @type {string}
 */
export const LOGIN_MODAL_COMPONENT = 'login-modal-component';
